module.exports = __webpack_public_path__ + "media/פלפל.70152e95.mp3";